import { NudosGenericModal, NudosModalContent } from 'components/NudosComponents';
import MarkAsCtoModalContent from './MarkAsCtoModalContent';
import './MarkAsCtoModalContent.scss';

interface IMarkAsCtoModal {
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Modal de confirmación para marcar una herramienta como CTO.
 * Envuelve el overlay genérico y delega el contenido a MarkAsCtoModalContent.
 */
const MarkAsCtoModal = (props: IMarkAsCtoModal) => {
  return (
    <NudosGenericModal
      closeModalCallback={props.onClose}
      clickOutsideCallback={props.onClose}
      customClassName="markAsCtoModal"
      modalContent={
        <NudosModalContent
          customWidth="46.6rem"
          customHeight="auto"
          excludeHeader
          isSectionContainerFull
          CustomModalComponent={<MarkAsCtoModalContent {...props} />}
        />
      }
    />
  );
};

export default MarkAsCtoModal;
